import React from "react";
import ReactDOM from "react-dom/client";
import Header from "./components/Header";
import Body from "./components/Body";
import Footer from "./components/Footer";

console.log("hello Shubham");

const AppLayout = () => {
    return (
        <div>
            <header>
                {/* <Header /> */}
            </header>
            <main className="flex-grow">
                <Body />
            </main>
            <footer className="mt-auto">
                <Footer />
            </footer>
        </div>
    )
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<AppLayout />);